import script from "./TileProjectDashboardPhases.vue?vue&type=script&setup=true&lang=ts"
export * from "./TileProjectDashboardPhases.vue?vue&type=script&setup=true&lang=ts"

import "./TileProjectDashboardPhases.vue?vue&type=style&index=0&id=2a9bf65d&scoped=true&lang=css"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a9bf65d"]])

export default __exports__